import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { WfdPriorityType } from '../../enums/wfd-priority.enum';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Owner } from '../../helpers/owner.decorator';

@Owner('Stat-Force 1')
@Component({
    selector: 'nova-wfd-referral-chip',
    standalone: true,
    imports: [MatChipsModule, MatIconModule, MatTooltipModule, NgClass],
    template: `
        <mat-chip
            [ngClass]="isCompact ? 'compact' : ''"
            color="info"
            data-qa-id="wfd-referral-priority"
            [disabled]="isDisabled"
            [matTooltipHideDelay]="hideDelay"
            [matTooltip]="tooltipText"
            [matTooltipDisabled]="tooltipDisabled"
            matTooltipPosition="above">
            <mat-icon matChipAvatar>chat</mat-icon>
            {{ WfdPriorityType.Referral }}
        </mat-chip>
    `,
    styleUrls: ['./chip.component.scss']
})
export class WfdReferralChipComponent {
    @Input() isDisabled = false;
    @Input() isCompact = false;
    @Input() tooltipText = 'Candidate referred by the client';
    @Input() hideDelay = 500;
    @Input() tooltipDisabled = false;

    WfdPriorityType = WfdPriorityType;
}
